// extracted by mini-css-extract-plugin
export var articleButton = "highlightedArticles-module--articleButton--b1f3c";
export var articleCardContainer = "highlightedArticles-module--articleCardContainer--5b533";
export var articleDescription = "highlightedArticles-module--articleDescription--ce3fe";
export var articleInfo = "highlightedArticles-module--articleInfo--3e10a";
export var articleTitle = "highlightedArticles-module--articleTitle--96d02";
export var articleTitleContainer = "highlightedArticles-module--articleTitleContainer--f8a5e";
export var articlesContainer = "highlightedArticles-module--articlesContainer--350c0";
export var carouselButtons = "highlightedArticles-module--carouselButtons--a6dac";
export var container = "highlightedArticles-module--container--75ddb";
export var icon = "highlightedArticles-module--icon--bb45a";
export var introText = "highlightedArticles-module--introText--16f13";
export var nextButton = "highlightedArticles-module--nextButton--611f7";
export var prevButton = "highlightedArticles-module--prevButton--82a34";
export var title = "highlightedArticles-module--title--3eae4";
export var titleContainer = "highlightedArticles-module--titleContainer--0aeb6";